"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDialogContainerStyle = getDialogContainerStyle;
exports.getDialogStyle = getDialogStyle;
exports.getModalBodyStyle = getModalBodyStyle;
exports.getRootStyle = getRootStyle;

var _constants = require("./constants");

const positionToAlignItems = {
  [_constants.Position.TOP]: 'start',
  [_constants.Position.CENTER]: 'center',
  [_constants.Position.BOTTOM]: 'end'
};

function getDialogContainerStyle(position) {
  return {
    alignItems: positionToAlignItems[position]
  };
}

function getDialogStyle(size) {
  const margin = size === 'full' ? 0 : size === 'mobile' ? '1.5rem' : '3rem';
  const style = {
    marginTop: margin,
    marginRight: margin,
    marginBottom: margin,
    marginLeft: margin
  };

  if (size === 'mobile') {
    style.width = '350px';
  }

  return style;
}

function getModalBodyStyle() {
  return {
    marginTop: 0,
    marginRight: 0,
    marginBottom: 0,
    marginLeft: 0
  };
}

function getRootStyle(zIndex) {
  const style = {};

  if (zIndex) {
    style.zIndex = zIndex;
  }

  return style;
}